<template>
	<div class="detail-card-list-row">
		<div v-if="labelList.length" class="detail-card-list-row-label" :style="{'grid-template-columns': columns ? columns.join(' ') : ''}">
			<p v-for="(label, i) in labelList" :key="i">{{label}}</p>
		</div>
		<div class="detail-card-list-row-content" :style="{'grid-template-columns': columns ? columns.join(' ') : ''}">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'detailCardListRow',

		props: {
			columns: {
				type: Array,
				default() {
					return ['1fr']
				}
			},
			label: [String, Array]
		},

		computed: {
			labelList() {
				return typeof this.label == 'string' ? [this.label] : this.label;
			}
		},

		mounted() {
			this.$parent.$options.name == 'detailCardList' && (this.$parent.rows = true);
		}
	}
</script>

<style lang="stylus" scoped>
	.detail-card-list-row {
		&-label,
		&-content {
			display: grid;
			grid-gap: .16rem;
		}

		&-label {
			padding: .05rem 0 .1rem;
			font-size: .26rem;
			color: #666;

			p {
				text-indent: .05rem;
			}
		}

		>>> .c-input,
		>>> .c-select,
		>>> .c-datetime {
			height: .6rem;
			background: #FFFAAD;
		}
	}
</style>
